import {
  getBaseHeaders,
  getExcelBaseHeaders,
  getFormDataHeaders,
  getDefaultHeaders,
  getTxtBaseHeaders,
  getZipBaseHeaders,
  getSimpleZipBaseHeaders, getAcceptCSVHeaders, getAuthHeader,
} from "./headers";
import { accounting_urls } from "./endpoints";
import { handleApiResponse } from "../utils/handleApiResponse";

/*
  PAYMENTS API
*/

// REPORTS GROUP
export const getReservationsReport = (token, { _from, _to }) =>
  fetch(accounting_urls.common.reports.reservations(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  })
    .then((r) => r.json())
    .then((r) => ({
      movements: r.reservations.map((reservation) => ({
        ...reservation,
        paymentInfo: reservation.payment,
        movement_id: reservation.reservation?.id,
        property_id: reservation.property?.id,
        description: `${reservation.type}: ${reservation.payment?.type}`,
        payment: reservation.payment?.amount,
        date: reservation.payment?.date,
        method: reservation.payment?.servipag_uid,
      })),
    }));

export const getContractsReport = (token, { _from, _to }) =>
  fetch(accounting_urls.common.reports.contracts(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  })
    .then((r) => r.json())
    .then((r) => ({
      movements: r.contracts.map((contract) => ({
        ...contract,
        paymentInfo: contract.payment,
        movement_id: contract.contract_payment?.id,
        subscription_id: contract.quotation?.id,
        property_id: contract.property?.id,
        description: `Propietario: ${contract.owner?.name} ${contract.owner?.last_name}`,
        payment: contract.payment?.amount,
        date: contract.payment?.date,
        method: contract.payment?.servipag_uid,
      })),
      summary: r.summary,
    }));

export const getLeasesReport = (token, { _from, _to }) =>
  fetch(accounting_urls.common.reports.leases(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  })
    .then((r) => r.json())
    .then((r) => ({
      movements: r.leases.map((lease) => ({
        ...lease,
        paymentInfo: lease.payment,
        movement_id: lease.payment_order?.id,
        subscription_id: lease.quotation?.id,
        property_id: lease.property?.id,
        description: `Propietario: ${lease.owner?.name} ${lease.owner?.last_name}`,
        payment: lease.payment?.breakdown?.owner?.total_payment,
        date: lease.payment?.date,
        method: lease.payment?.servipag_uid,
      })),
      summary: r.summary,
    }));

// USERS GROUP
export const getUser = (token, id) =>
  fetch(accounting_urls.users.user(id), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

// Payment Tools
export const getPaymentsSummary = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.payroll.paymentsSummary(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

// DOWNLOADS

//----------
// Chile
//----------

export const getExcelDirectPayments = (token, { _from, _to }) =>
  fetch(accounting_urls.common.payroll.directPayments(_from, _to), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const getExcelOnlyBrokerage = (token, { _from, _to }) =>
  fetch(accounting_urls.common.payroll.onlyBrokerage(_from, _to), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const getExcelGuaranteedPayments = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.payroll.guaranteedPayments(_from, _to), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const getExcelWarrantyPayments = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.payroll.warrantyPayments(_from, _to), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const getExcelNormalPayments = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.payroll.basicPayments(_from, _to), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const getExcelRefundPayments = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.payroll.refundPayments(_from, _to), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const postExcelPayments = (token, formData) =>
  fetch(accounting_urls.cl.payroll.uploadPayments(), {
    method: "POST",
    headers: getFormDataHeaders(token),
    body: formData
  });

export const postWarrantyUploadPayroll = (token, formData) =>
  fetch(accounting_urls.cl.payroll.warrantyUploadPayroll(), {
    method: "POST",
    headers: getFormDataHeaders(token),
    body: formData
  })


//----------
// Colombia
//----------
export const getBankAccountsRegister = (token, { _from, _to }) =>
  fetch(accounting_urls.co.downloads.bankAccounts.register(_from, _to), {
    method: "GET",
    headers: getTxtBaseHeaders(token),
  }).then((r) => r.blob());

export const getOutflowsPayroll = (token, { _from, _to }) =>
  fetch(accounting_urls.co.downloads.movements.payroll(_from, _to), {
    method: "GET",
    headers: getTxtBaseHeaders(token),
  }).then((r) => r.blob());

export const getOutflowsPayrollJPM = (token, { _from, _to }) =>
  fetch(accounting_urls.co.payroll.download.jpm(_from, _to), {
    method: "GET",
    headers: Object.assign({}, getAcceptCSVHeaders(), getAuthHeader(token),)
  });

export const getRefundPayrollJPM = (token, { _from, _to }) =>
  fetch(accounting_urls.co.payroll.download.jpm_refund(_from, _to), {
    method: "GET",
    headers: Object.assign({}, getAcceptCSVHeaders(), getAuthHeader(token),)
  });

export const postOutflowsPayrollJPM = (token, formData) =>
  fetch(accounting_urls.co.payroll.upload.jpm(), {
    method: "POST",
    headers: getFormDataHeaders(token),
    body: formData
  });

export const postBankAccountsRegister = (token, formData) =>
  fetch(accounting_urls.co.uploads.bankAccounts.register(), {
    method: "PUT",
    headers: getFormDataHeaders(token),
    body: formData,
  }).then((r) => r.json());

export const postOutflowsPayroll = (token, formData, { _from, _to }) =>
  fetch(accounting_urls.co.uploads.movements.payroll(_from, _to), {
    method: "PUT",
    headers: getFormDataHeaders(token),
    body: formData,
  }).then((r) => r.json());

export const getInvoicingDetail = (token) =>
  fetch(accounting_urls.co.downloads.movements.invoicing(), {
    method: "GET",
    headers: getExcelBaseHeaders(token),
  }).then((r) => r.blob());

export const getInvoicingReportDetail = (token, dateFrom, dateTo) =>
  fetch(
    accounting_urls.co.downloads.movements.invoicing_report(dateFrom, dateTo),
    {
      method: "GET",
      headers: getSimpleZipBaseHeaders(token),
    },
  ).then((r) => r.blob());

//----------
// Mexico
//----------
export const getRegistrationFormMX = (token, { _to }) =>
  fetch(accounting_urls.mx.downloads.registrationForm(_to), {
    method: "GET",
    headers: getTxtBaseHeaders(token),
  }).then((r) => r.blob());

export const getPayrollMX =
  (internal) =>
  (token, { _from, _to }) =>
    fetch(accounting_urls.mx.downloads.payroll(_from, _to, internal), {
      method: "GET",
      headers: getTxtBaseHeaders(token),
    }).then((r) => r.blob());

export const getPayrollMXJPM =
  (token, { _from, _to }) =>
    fetch(accounting_urls.mx.downloads.payroll_jpm(_from, _to), {
      method: "GET",
      headers: Object.assign({}, getAcceptCSVHeaders(), getAuthHeader(token),)
    });

export const getRefundPayrollMXJPM =
  (token, { _from, _to }) =>
    fetch(accounting_urls.mx.downloads.payroll_jpm_refund(_from, _to), {
      method: "GET",
      headers: Object.assign({}, getAcceptCSVHeaders(), getAuthHeader(token),)
    });

export const postOutflowsPayrollMXJPM = (token, formData) =>
  fetch(accounting_urls.mx.uploads.payroll_jpm(), {
    method: "POST",
    headers: getFormDataHeaders(token),
    body: formData
  });

export const putRegistrationFormMX = (token, formData) =>
  fetch(accounting_urls.mx.uploads.registrationForm(), {
    method: "PUT",
    headers: getFormDataHeaders(token),
    body: formData,
  }).then((r) => r.json());

export const putPayrollMX = (internal) => (token, formData, { _from, _to }) =>
  fetch(accounting_urls.mx.uploads.payroll(internal, _from, _to), {
    method: "PUT",
    headers: getFormDataHeaders(token),
    body: formData,
  }).then((r) => r.json());

/**
  PAYMENTS API V2
*/

export const getBankAccounts = (country, token, id) =>
  fetch(accounting_urls[country].people.bank_accounts.all(id), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getBankAccountRecord = (country, token, personId, identifier) =>
  fetch(
    accounting_urls[country].paymentSite.bankAccounts.record(personId, identifier),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

// Both go through handleApiResponse: this POST is the one place in the app that
// changes where a landlord gets paid, so a rejected field has to reach the
// operator as text, not as a silently swallowed 422.
export const createBankAccount = (country, token, personId, body) =>
  fetch(accounting_urls[country].paymentSite.bankAccounts.create(personId), {
    method: "POST",
    headers: getBaseHeaders(token),
    body: JSON.stringify(body),
  }).then(handleApiResponse);

// Through handleApiResponse, not `.json()`, because the caller has to tell a
// 404 ("this property has no account") apart from a real failure. Both would
// otherwise arrive as a body with no `bank_accounts` key and render as an empty
// table, which reads as "no account" even when the request was rejected.
export const searchBankAccountByProperty = (country, token, propertyId) =>
  fetch(accounting_urls[country].paymentSite.bankAccounts.searchByProperty(propertyId), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);

export const getBanks = (country, token) =>
  fetch(accounting_urls[country].banks.all(), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);

export const getMovements = (
  country,
  token,
  type,
  concept,
  status,
  { _from, _to },
) =>
  fetch(
    accounting_urls[country].movements.get.all(
      type,
      concept,
      status,
      _from,
      _to,
    ),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

export const getServipagLogs = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.servipag.logs.get.all(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getMovementByServipagUID = (token, servipagUid) =>
  fetch(accounting_urls.common.movements.search("servipag_uid", servipagUid), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getMovement = (country, token, id) =>
  fetch(accounting_urls[country].movements.get.single(id), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getGroup = (country, token, id) =>
  fetch(accounting_urls[country].movements.get.group(id), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getJournalByMovementID = (country, token, movementId = null, batchId = null) =>
  fetch(accounting_urls.erp.journal(country, movementId, batchId), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getERPSyncOverview = (country, period, token) =>
  fetch(accounting_urls.erp.sync.overview(country, period), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);

export const getERPSyncStrategies = (country, period, token) =>
  fetch(accounting_urls.erp.sync.strategies(country, period), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);

export const getERPOracleRequests = (country, token, statuses, limit) => {
  const url = new URL(accounting_urls.erp.oracle.sync.list(country));
  if (statuses && statuses.length > 0) {
    statuses.forEach(s => url.searchParams.append("statuses", s));
  }
  if (limit) {
    url.searchParams.append("limit", limit);
  }

  return fetch(url.toString(), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);
};

export const triggerOracleSync = (country, token, movementIds) =>
  fetch(accounting_urls.erp.oracle.sync.trigger(country), {
    method: "POST",
    headers: getBaseHeaders(token),
    body: JSON.stringify({ movement_ids: movementIds }),
  }).then(handleApiResponse);

export const getERPOracleRequestDetail = (country, requestId, token) =>
  fetch(accounting_urls.erp.oracle.sync.detail(country, requestId), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);

export const getMovementsBySubscription = (
  country,
  token,
  id,
  getOnly,
  { _from, _to },
) =>
  fetch(
    accounting_urls[country].subscriptions.movements.get(
      id,
      getOnly,
      _from,
      _to,
    ),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

// ADJUSTMENT REASONS
export const getAdjustmentReasons = (token, filters = {}) => {
  const url = new URL(accounting_urls.adjustmentReasons.list());
  Object.entries(filters).forEach(([key, value]) => {
    if (value) url.searchParams.set(key, value);
  });

  return fetch(url.toString(), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then(handleApiResponse);
};

export const createAdjustmentReason = (token, body) =>
  fetch(accounting_urls.adjustmentReasons.list(), {
    method: "POST",
    headers: getBaseHeaders(token),
    body: JSON.stringify(body),
  }).then(handleApiResponse);

export const updateAdjustmentReason = (token, reasonId, body) =>
  fetch(accounting_urls.adjustmentReasons.detail(reasonId), {
    method: "PATCH",
    headers: getBaseHeaders(token),
    body: JSON.stringify(body),
  }).then(handleApiResponse);

export const uploadServipagLogs = (token, formData) =>
  fetch(accounting_urls.cl.servipag.uploadTxt(token), {
    method: "POST",
    headers: getFormDataHeaders(token),
    body: formData,
  }).then((r) => r.json());

export const getDuplicatedPayrollPayments = (
  token,
  from,
  to,
  type,
  get_duplicates,
  fileFormData,
) =>
  fetch(
    accounting_urls.cl.payroll.checkDuplicated(from, to, type, get_duplicates),
    {
      method: "POST",
      headers: getFormDataHeaders(token),
      body: fileFormData,
    },
  ).then((r) => r.blob());

export const uploadPayrollPayments = (token, date, type, fileFormData) =>
  fetch(accounting_urls.cl.payroll.uploadDuplicatedPayroll(date, type), {
    method: "PUT",
    headers: getFormDataHeaders(token),
    body: fileFormData,
  }).then((r) => r.json());

// BACKEND API
export const getAppraisers = () =>
  fetch(accounting_urls.appraisers.all(), {
    method: "GET",
    headers: getDefaultHeaders(),
  }).then((r) => r.json());

export const getExecutives = () =>
  fetch(accounting_urls.executives.all(), {
    method: "GET",
    headers: getDefaultHeaders(),
  }).then((r) => r.json());

// COMMISSIONS API
export const getAppraiserCommission = (country, token, id, from, to) =>
  fetch(
    accounting_urls[country].commissions.appraisers.commission(id, from, to),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

export const getAppraiserReport = (country, token, id, from, to, name) =>
  fetch(
    accounting_urls[country].commissions.appraisers.report(id, from, to, name),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.blob());

export const getAppraiserResume = (country, token, from, to, appraisers) =>
  fetch(accounting_urls[country].commissions.appraisers.resume(from, to), {
    method: "POST",
    headers: getBaseHeaders(token),
    body: JSON.stringify(appraisers),
  }).then((r) => r.blob());

export const getAppraisersBankReport = (country, token, from, to, appraisers) =>
  fetch(accounting_urls[country].commissions.appraisers.bankReport(from, to), {
    method: "POST",
    headers: getBaseHeaders(token),
    body: JSON.stringify(appraisers),
  }).then((r) => r.blob());

export const getAllAppraisersReports = (country, token, from, to, appraisers) =>
  fetch(accounting_urls[country].commissions.appraisers.allReports(from, to), {
    method: "POST",
    headers: getZipBaseHeaders(token),
    body: JSON.stringify(appraisers),
  }).then((r) => r.blob());

export const getExecutiveCommission = (country, token, id, from, to) =>
  fetch(
    accounting_urls[country].commissions.executives.commission(id, from, to),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

export const getExecutiveReport = (country, token, id, to, name) =>
  fetch(accounting_urls[country].commissions.executives.report(id, to, name), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.blob());

// TREASURY

export const getTreasuryMovements = (country, token, filters) => {
  const url = new URL(accounting_urls[country].treasury.movements.list());
  // Required
  url.searchParams.set("from", filters.from);
  url.searchParams.set("to", filters.to);
  // Pagination
  if (filters.page) url.searchParams.set("page", filters.page);
  if (filters.per_page) url.searchParams.set("per_page", filters.per_page);
  // Optional filters
  if (filters.movement_type) {
    filters.movement_type.forEach((v) => url.searchParams.append("movement_type", v));
  }
  if (filters.movement_concept) {
    filters.movement_concept.forEach((v) => url.searchParams.append("movement_concept", v));
  }
  if (filters.movement_status) {
    filters.movement_status.forEach((v) => url.searchParams.append("movement_status", v));
  }
  if (filters.subscription_ids) {
    filters.subscription_ids.forEach((v) => url.searchParams.append("subscription_ids", v));
  }
  if (filters.property_ids) {
    filters.property_ids.forEach((v) => url.searchParams.append("property_ids", v));
  }
  return fetch(url.toString(), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());
};

export const patchTreasuryAgreedDate = (country, token, body) =>
  fetch(accounting_urls[country].treasury.movements.bulkUpdateAgreedDate(), {
    method: "PATCH",
    headers: getBaseHeaders(token),
    body: JSON.stringify(body),
  }).then((r) => {
    if (!r.ok) {
      return r.json().then((err) => Promise.reject(err));
    }
    return r.json();
  });

/** Payments API v3 */
export const getCLPaymentsInfoV3 = (token, { _from, _to }) =>
  fetch(accounting_urls.cl.paymentTools.paymentInfo(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getCLPaymentsStatistics = (
  token,
  { _from, _to, movement_type = [], movement_concept = [], movement_status = [] },
) =>
  fetch(
    accounting_urls.cl.paymentTools.statisticsPayments(
      _from,
      _to,
      movement_type,
      movement_concept,
      movement_status,
    ),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

export const getCOPaymentsInfoV3 = (token, { _from, _to }) =>
  fetch(accounting_urls.co.paymentTools.paymentInfo(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getCOPaymentsStatistics = (
  token,
  { _from, _to, movement_type = [], movement_concept = [], movement_status = [] },
) =>
  fetch(
    accounting_urls.co.paymentTools.statisticsPayments(
      _from,
      _to,
      movement_type,
      movement_concept,
      movement_status,
    ),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

export const getMXPaymentsInfoV3 = (token, { _from, _to }) =>
  fetch(accounting_urls.mx.paymentTools.paymentInfo(_from, _to), {
    method: "GET",
    headers: getBaseHeaders(token),
  }).then((r) => r.json());

export const getMXPaymentsStatistics = (
  token,
  { _from, _to, movement_type = [], movement_concept = [], movement_status = [] },
) =>
  fetch(
    accounting_urls.mx.paymentTools.statisticsPayments(
      _from,
      _to,
      movement_type,
      movement_concept,
      movement_status,
    ),
    {
      method: "GET",
      headers: getBaseHeaders(token),
    },
  ).then((r) => r.json());

/**
 * Legacy Wrapper V1
 */
export const getMovementsCL = (token, concept, { _from, _to }) => {
  const reports = {
    reservation: getReservationsReport,
    contract: getContractsReport,
    lease: getLeasesReport,
  };
  return reports[concept](token, { _from, _to });
};
